import React from 'react';

function SectionIntro({ label, title, children, dark = false }) {
  return (
    <header className={`section-intro ${dark ? 'section-intro-dark' : ''}`}>
      <p className="section-label">{label}</p>
      <h2>{title}</h2>
      {children}
    </header>
  );
}

export default SectionIntro;